const AllOrders = (props) => {
  // const [active, setActive] = useState(0)
  console.log("mounting orders", props.orders);
  const orders = props.orders;
  // console.log(orders);
  let d = 0; //delivered
  let c = 0; //cancelled
  let i = 0; //inprogress
  orders?.map((item) => {
    if (item.status == "delivered") d++;
    if (item.status == "completed") d++;

    if (item.status == "cancelled") c++;
    if (item.status == "inprogress") i++;
  });
  // setActive(c);

  const calculateOrderStatusCounts = (orders) => {
    const initialCounts = {
      pending: 0,
      inprogress: 0,
      cancelled: 0,
      delivered: 0,
      total: 0,
    };

    const statusCounts = orders?.reduce((counts, order) => {
      if (order.status) {
        counts[order.status] = (counts[order.status] || 0) + 1;
        counts.total = (counts.total || 0) + 1; // Increment the total count
      }
      return counts;
    }, initialCounts);

    return statusCounts;
  };

  const totalCounts = calculateOrderStatusCounts(orders);
  console.log("totalcounts", totalCounts);
  return (
    <div className="abandoned-main">
      {/* <div className="abandoned-div"> */}
      {/* <img alt="cart-img" src={BagBlack} className="cart-image" /> */}
      {/* <select>
          <option>This Week</option>
          <option>This Month</option>
          <option>This Year</option>
        </select> */}
      {/* </div> */}
      <div className="abandoned-body">
        <div className="abandoned-body-item">
          <p className="abandoned-body-title">All {props.type}</p>
          {/* <p className="cart-percentage">{orders?.length}</p> */}
          <p className="cart-percentage">{totalCounts?.total || "-"}</p>
        </div>
        <div className="abandoned-body-item">
          <p className="abandoned-body-title">Pending</p>
          {/* <p className="cart-percentage">{orders?.length - (d + i + c)}</p> */}
          <p className="cart-percentage">{totalCounts?.pending || "-"}</p>
        </div>
        <div className="abandoned-body-item">
          <p className="abandoned-body-title">In Progress</p>
          {/* <p className="cart-percentage">{i}</p> */}
          <p className="cart-percentage">{totalCounts?.inprogress || "-"}</p>
        </div>

        <div className="abandoned-body-item">
          <p className="abandoned-body-title">
            {props.type == "Orders" ? "Delivered" : "Completed"}
          </p>
          <p className="cart-percentage">
            {totalCounts?.delivered || "-"}
            {/* <span>+0.00%</span> */}
          </p>
        </div>

        <div className="abandoned-body-item">
          <p className="abandoned-body-title">Cancelled</p>
          {/* <p className="cart-percentage">{c}</p> */}
          <p className="cart-percentage">{totalCounts?.cancelled || "-"}</p>
        </div>
      </div>
    </div>
  );
};

export default AllOrders;
